import { render } from "./NonPharmaceuticalFormTab.vue?vue&type=template&id=1cff6876"
import script from "./NonPharmaceuticalFormTab.vue?vue&type=script&lang=js"
export * from "./NonPharmaceuticalFormTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__